var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9564 27.0869V33.6086",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91303 45.3486H3.60869C2.16795 45.3486 1 44.1807 1 42.7399V21.8704C1 20.4297 2.16795 19.2617 3.60869 19.2617H32.3043C33.745 19.2617 34.913 20.4297 34.913 21.8704V33.6095",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6959 19.2608V12.7391C29.6959 6.25577 24.4401 1 17.9568 1C11.4734 1 6.21765 6.25577 6.21765 12.7391V19.2608",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4347 41.1299C11.4347 40.5776 11.8824 40.1299 12.4347 40.1299H59.9998C60.5521 40.1299 60.9998 40.5776 60.9998 41.1299V59.9994C60.9998 60.5517 60.5521 60.9994 59.9998 60.9994H12.4347C11.8824 60.9994 11.4347 60.5517 11.4347 59.9994V41.1299Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9564 46.6514L25.7825 54.4774",
    stroke: "#37E7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7825 46.6514L17.9564 54.4774",
    stroke: "#37E7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3041 46.6514L40.1301 54.4774",
    stroke: "#37E7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1301 46.6514L32.3041 54.4774",
    stroke: "#37E7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3475 55.7822H55.7823",
    stroke: "#37E7A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9562 26.4355C18.3164 26.4355 18.6084 26.7275 18.6084 27.0877C18.6084 27.4479 18.3164 27.7399 17.9562 27.7399C17.5961 27.7399 17.3041 27.4479 17.3041 27.0877C17.3041 26.7275 17.5961 26.4355 17.9562 26.4355",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLock);
export default __webpack_public_path__ + "static/media/PasswordLock.c271e4ff.svg";
export { ForwardRef as ReactComponent };